export const modalIdKey = 'modal';
